import { isEqualWith, isNull } from 'lodash-es';
import { UntypedFormArray } from '@angular/forms';
import { INimbusFormGroup } from '@nimbus-library/features/shared/angular/forms/i-nimbus-form-group';

export function isFormValueEqual(value: unknown, valueOriginal: unknown): boolean {
  return isEqualWith(value, valueOriginal, (a, b) => {
    if ((isNull(a) || a === '') && (isNull(b) || b === '')) {
      return true;
    }
  });
}

export function getFormGroupErrors<TForm>(form: INimbusFormGroup<TForm>): object {
  return Object.keys(form.controls).reduce((errors, controlId) => {
    const control = form.controls[controlId];
    if (control instanceof UntypedFormArray) {
      return (control.controls as INimbusFormGroup<unknown>[]).map((f) => getFormGroupErrors(f));
    } else {
      errors[controlId] = control.errors;
      return errors;
    }
  }, {});
}

export function setFormGroupErrors<TForm>(form: INimbusFormGroup<TForm>, errors: unknown): void {
  if (!errors) {
    return;
  }
  Object.keys(errors).forEach((x) => {
    const control = form.controls[x];
    if (!!control) {
      if (control instanceof UntypedFormArray) {
        (control.controls as INimbusFormGroup<unknown>[]).forEach((f, i) => setFormGroupErrors(f, errors[x][i]));
      } else {
        if (!!errors[x]) {
          control.setErrors(errors[x]);
          control.markAsDirty();
        }
      }
    }
  });
  form.updateValueAndValidity();
}
